var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api } from 'api';
import { useState, useCallback, useRef, useEffect } from 'react';
import { useNotification } from '../../notifications';
export var useDeleteAttachment = function () {
    var liveNotification = useNotification().liveNotification;
    var _a = useState({}), deletionStatus = _a[0], setDeletionStatus = _a[1];
    var _b = useState({}), deletionError = _b[0], setDeletionError = _b[1];
    var _c = useState({}), deletionData = _c[0], setDeletionData = _c[1];
    var abortControllers = useRef(new Map());
    var execute = useCallback(function (_a) {
        var offerId = _a.offerId, attachmentId = _a.attachmentId;
        return __awaiter(void 0, void 0, void 0, function () {
            var deletionKey, controller, signal, response_1, error_1, errorMsg_1;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        deletionKey = "".concat(offerId, "-").concat(attachmentId);
                        if (abortControllers.current.has(deletionKey)) {
                            abortControllers.current.get(deletionKey).abort();
                        }
                        controller = new AbortController();
                        signal = controller.signal;
                        abortControllers.current.set(deletionKey, controller);
                        setDeletionStatus(function (prevStatus) {
                            var _a;
                            return (__assign(__assign({}, prevStatus), (_a = {}, _a[deletionKey] = 'loading', _a)));
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, api.utils.apiUtilsDeleteAttachmentIdDelete(attachmentId, offerId, { signal: signal })];
                    case 2:
                        response_1 = _d.sent();
                        if (response_1.data) {
                            setDeletionData(function (prevData) {
                                var _a;
                                return (__assign(__assign({}, prevData), (_a = {}, _a[deletionKey] = response_1.data, _a)));
                            });
                            setDeletionStatus(function (prevStatus) {
                                var _a;
                                return (__assign(__assign({}, prevStatus), (_a = {}, _a[deletionKey] = 'fetched', _a)));
                            });
                            setDeletionError(function (prevError) {
                                var _a;
                                return (__assign(__assign({}, prevError), (_a = {}, _a[deletionKey] = null, _a)));
                            });
                            liveNotification('success', "Attachment ".concat(attachmentId, " deleted successfully"));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _d.sent();
                        if (!signal.aborted) {
                            errorMsg_1 = ((_c = (_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || error_1.message;
                            setDeletionStatus(function (prevStatus) {
                                var _a;
                                return (__assign(__assign({}, prevStatus), (_a = {}, _a[deletionKey] = 'error', _a)));
                            });
                            setDeletionError(function (prevError) {
                                var _a;
                                return (__assign(__assign({}, prevError), (_a = {}, _a[deletionKey] = errorMsg_1, _a)));
                            });
                            liveNotification('error', "Error deleting attachment ".concat(attachmentId, ": ").concat(errorMsg_1));
                        }
                        else {
                            console.log("Delete request for attachment ".concat(attachmentId, " was aborted"));
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        abortControllers.current.delete(deletionKey);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [liveNotification]);
    useEffect(function () {
        return function () {
            abortControllers.current.forEach(function (controller) { return controller.abort(); });
            abortControllers.current.clear();
            setDeletionStatus({});
            setDeletionError({});
            setDeletionData({});
        };
    }, []);
    return { deletionStatus: deletionStatus, deletionError: deletionError, deletionData: deletionData, execute: execute };
};
